













































































import { Component, Vue } from 'vue-property-decorator';
import swert from '@/component/swert.vue';
import wx from '@/util/wx';
import Cookies from 'js-cookie';

const { VUE_APP_FCAPI_LIULIANGPHONE: FCAPI } = process.env;

const API = {
  apply: `${FCAPI}/weixin/mina/ruan/butler/apply`,
  list: `${FCAPI}/weixin/mina/ruan/butler`
};

@Component({
  components: {
    swert,
  },
})
export default class RuanApply extends Vue {
  swert_msg: string = '';
  submit_data: any = {
    name: '',
    mobile: '',
    address: '',
    area: '',
    remark: '',
    assistant_id: '',
    assistant_name: '',
  };
  assistant_id: any = {};
  // pattern: any = /^(1\d{10})$/;
  steward_val: any = '';
  showPicker: boolean = false;
  columns: any = [];

  async onSubmit(value: any) {
    const res = await this.$axios.post(API.apply, {
      ...this.submit_data,
      name: this.submit_data.name ? this.submit_data.name : '软装用户',
      merchant_id: this.$route.query.merchant_id,
      area: this.submit_data.area ? this.submit_data.area : 0,
      // assistant_id: this.assistant_id.id,
      // assistant_name: this.assistant_id.weixin_nickname,
    });
    if (res.data.status === 200) {
      this.swert_msg = '录入成功';
      this.submit_data = {
        name: '',
        mobile: '',
        address: '',
        area: '',
        remark: '',
        assistant_id: '',
        assistant_name: '',
      };
    } else {
      this.swert_msg = res.data.message;
      // this.$toast(res.data.message);
    }
    // res.data.status === 200 ? () => {
    // } : this.$toast(res.data.message);
    // ('报名成功')
    // if (res.data.status === 200) {
    //   this.$toast.success('报名成功');
    // } else {

    // }
    console.log(value);
  }

  chooseAssistant(value: any) {
    this.submit_data.assistant_id = value.id;
    this.submit_data.assistant_name = value.weixin_nickname;
    this.showPicker = false;
    console.log(value);
  }

  async init() {
    const res = await this.$axios.get(`${API.list}?merchant_id=${this.$route.query.merchant_id}&status=1`);
    if (res.data.status !== 200) {
      this.$toast.fail(res.data.message);
    }
    console.log(this.$route.query.userId);
    if (this.$route.query.userId) {
      console.log(res.data.data);
      const default_data = res.data.data.filter((item: any) => {
        return item.id.toString() === this.$route.query.userId;
      });
      console.log(default_data);
      this.submit_data.assistant_id = default_data[0].id | 0;
      this.submit_data.assistant_name = default_data[0].weixin_nickname;
    }
    this.columns = res.data.data;
  }
  created() {
    this.init();
    window.SHARE = {
      title: '用户录入', // 分享标题
      description: '', // 分享描述
      url: window.location.href, // 分享链接
      icon_url: 'https://static.tugou.com/tugouguanjia/logo.png', // 分享图片
    };
    this.$wx.bindShare();
    this.$wx.bindShareTimeLine();
  }
}
